import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import ListSkeleton from '#app/components/application/components/application/ListSkeleton';
import GridContainer from '#app/components/layout/GridContainer/GridContainer';
import UnexpectedError from '#app/interface/error/UnexpectedError';
import CabinetLayout from '#app/pagesRouter/CabinetLayout';

import {
  ApplicationPage,
  Cabinet,
  CalendarFilter,
  CalendarPage,
  ClientsPage,
  Common,
  EventTranscription,
  FunnelPage,
  Hierarchy,
  Learn,
  LearnAton,
  TestPage,
} from './LazyLoadedPages';

interface CabinetRoutesProps {
  logout: () => void;
  [key: string]: any;
}

type RoutedComponent = React.ComponentType<CabinetRoutesProps>;

const ApplicationPageRoute = ApplicationPage as RoutedComponent;
const FunnelPageRoute = FunnelPage as RoutedComponent;
const HierarchyRoute = Hierarchy as RoutedComponent;
const LearnRoute = Learn as RoutedComponent;
const LearnAtonRoute = LearnAton as RoutedComponent;
const EventTranscriptionRoute = EventTranscription as RoutedComponent;
const CabinetRoute = Cabinet as RoutedComponent;

const CabinetRoutes: React.FC<CabinetRoutesProps> = ({ ...props }) => (
  <Routes>
    <Route element={<CabinetLayout />}>
      <Route path="/error" element={<UnexpectedError />} />
      <Route
        path="/calendar"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <GridContainer
              style={{
                gridTemplateColumns: 'auto 300px',
                gridTemplateRows: '1fr',
                gridGap: '0',
              }}
            >
              <CalendarPage
                style={{ gridColumn: '1', gridRowStart: '1', gridRowEnd: '2' }}
                {...props}
              />
              <CalendarFilter
                style={{ gridColumn: '2', gridRowStart: '1', gridRowEnd: '1' }}
                {...props}
              />
            </GridContainer>
          </Suspense>
        }
      />
      <Route
        path="/application"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <ApplicationPageRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/clients"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <ClientsPage {...props} />
          </Suspense>
        }
      />
      <Route
        path="/config"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <Common {...props} />
          </Suspense>
        }
      />
      <Route
        path="/funnel"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <FunnelPageRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/hierarchy"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <HierarchyRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/learn"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <LearnRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/learn/aton"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <LearnAtonRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/swanny"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <EventTranscriptionRoute {...props} />
          </Suspense>
        }
      />
      <Route
        path="/test"
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <TestPage {...props} />
          </Suspense>
        }
      />
      <Route
        path=""
        element={
          <Suspense fallback={<ListSkeleton count={12} />}>
            <CabinetRoute {...props} />
          </Suspense>
        }
      />
    </Route>
  </Routes>
);

export default CabinetRoutes;
